import { requireAdmin } from '@/Router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { create } from 'zustand';
const importSchema = z.object({
  type: z.literal('contacts').nullable().catch(null),
  file: z.instanceof(File).nullable().catch(null)
});
type ImportStore = z.infer<typeof importSchema> & {
  setFile: (file: File | null) => void;
};
export const useImportStore = create<ImportStore>(set => ({
  ...importSchema.parse({}),
  setFile: file => {
    set({
      file
    });
  }
}));
export const Route = createFileRoute('/dash/crm/contacts/import')({
  beforeLoad: () => {
    requireAdmin({
      to: '/dash/crm'
    });
  }
});